// @ts-nocheck
export const localeCodes =  [
  "fr",
  "en"
]
export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46json_b5672acd",
      load: () => import("#nuxt-i18n/b5672acd" /* webpackChunkName: "locale_fr_46json_b5672acd" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_09fcfdf2",
      load: () => import("#nuxt-i18n/09fcfdf2" /* webpackChunkName: "locale_en_46json_09fcfdf2" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c9fee111" /* webpackChunkName: "config_i18n_46config_46ts_c9fee111" */)
]
export const normalizedLocales = [
  {
    code: "fr",
    iso: "fr-FR",
    name: "Français",
    language: "fr-FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  }
]
/** client **/

/** client-end **/